import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const personalInformationsApi = api
  .enhanceEndpoints({
    addTagTypes: ["personal-informations", "personal-information"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      personalInformations: builder.query({
        query: ({ userId, status }) => ({
          url: `/personal-informations`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["personal-informations"],
      }),
      personalInformation: builder.query({
        query: ({ userId, status, id }) => ({
          url: `/personal-informations/${id}`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["personal-information"],
      }),
    }),
  });

export const { usePersonalInformationQuery, usePersonalInformationsQuery } =
  personalInformationsApi;
